import { ChevronLeft, ChevronRight } from "lucide-react"
import { Button } from "../ui"
import { FooterProps } from "./types"

const Footer = ({
  hideFooter,
  computedTotalRecords,
  pagination,
  setPagination,
  paginationArr, 
  table
}: FooterProps) => {
  return <>
    {!hideFooter && computedTotalRecords > 0 && (
      <div className="flex flex-wrap items-center justify-end p-4 gap-4 text-sm text-gray-500 text-[15px] border-t border-gray-100">
        <div className="flex items-center gap-2">
          <span>Rows per page:</span>
          <select
            className="rounded px-2 py-1 bg-white"
            value={pagination.pageSize}
            onChange={(e) =>
              setPagination((prev: any) => ({
                ...prev,
                pageSize: Number(e.target.value),
                pageIndex: 0,
              }))
            }
          >
            {paginationArr.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>

        <div>
          <span>
            {pagination.pageIndex * pagination.pageSize + 1} -{" "}
            {Math.min(
              (pagination.pageIndex + 1) * pagination.pageSize,
              computedTotalRecords
            )}{" "}
            of {computedTotalRecords}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
            className="p-1 h-auto shadow-none text-gray-500 hover:text-black disabled:opacity-40"
          >
            <ChevronLeft className="w-5 h-5" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
            className="p-1 h-auto shadow-none text-gray-500 hover:text-black disabled:opacity-40"
          >
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>
    )}
  </>
}

export default Footer;